import status from './status.js'
export const statusLabel = (labelmaker, statusCode, role = '0', negoCode = -1, direction = -1, user = {}) => {
  switch (statusCode) {
    case status.WAITING:
      switch (negoCode) {
        case '0':
          return labelmaker.t('common.status.waiting_request')
        case '10':
          switch (direction) {
            case 0:
              return labelmaker.t('common.status.negotiation_request_sent')
            case 1:
              return labelmaker.t('common.status.negotiation_request_received')
            default:
              return labelmaker.t('common.status.negotiation_request')
          }
        case '11':
          switch (direction) {
            case 0:
              return labelmaker.t('common.status.negotiation_response_received')
            case 1:
              return labelmaker.t('common.status.negotiation_response_sent')
            default:
              return labelmaker.t('common.status.negotiation_response')
          }
        default:
          return labelmaker.t('common.status.waiting_request')
      }
    case status.ACCEPTED:
      return labelmaker.t('common.status.accepted_request')
    case status.MODIFIED:
      return labelmaker.t('common.status.modified_request')
    case status.REVOKED:
      return labelmaker.t('common.status.revoked_request')
    case status.ORDER_GENERATED:
      return labelmaker.t('common.status.payment_order_generated')
    case status.ORDER_SENT:
      return labelmaker.t('common.status.payment_order_sent')
    case status.ORDER_NOT_SENT:
      return labelmaker.t('common.status.payment_order_not_sent')
    case status.ORDER_VALIDATED:
      return labelmaker.t('common.status.payment_order_validated')
    case status.ORDER_REJECTED:
      return labelmaker.t('common.status.payment_order_rejected')
    case status.MADE:
      return labelmaker.t('common.status.payment_made')
    case status.INSTALLMENT_PAID:
      return labelmaker.t('common.status.installment_paid')
    case status.INST_ORDER_GENERATED:
      return labelmaker.t('common.status.inst_order_generated')
    case status.INST_PAYMENT_SENT:
      return labelmaker.t('common.status.inst_payment_sent')
    case status.INST_PAYMENT_NOT_SENT:
      return labelmaker.t('common.status.inst_payment_not_sent')
    case status.INST_PAYMENT_VALIDATED:
      return labelmaker.t('common.status.inst_payment_validated')
    case status.INST_PAYMENT_REJECTED:
      return labelmaker.t('common.status.inst_payment_rejected')
    case status.INST_MADE:
      return labelmaker.t('common.status.inst_made')
    case status.CANCELED:
      return labelmaker.t('common.status.aborted_request')
    case status.CANCELED_CONFIRM:
      return labelmaker.t('common.status.cancel_confirmed')
    case status.CANCELED_ABORT:
      return labelmaker.t('common.status.cancel_aborted')
    case status.EXPIRED:
      return labelmaker.t('common.status.expired')
    case status.ACCEPTED_AND_PAYED:
      return labelmaker.t('common.status.accepted_nd_payed')
    case status.ACCEPTED_AND_PAYED_INST:
      return labelmaker.t('common.status.accepted_nd_payed_inst')
    case status.MODIFIED_AND_PAYED:
      return labelmaker.t('common.status.modified_n_pay_request')
    case status.MODIFIED_AND_PAYED_INST:
      return labelmaker.t('common.status.modified_n_pay_request_inst')
    case status.RECEIVED:
      return labelmaker.t('common.status.received_request')
    case status.REJECTED:
      return labelmaker.t('common.status.rejected_request')
    case status.INFORMATION:
      return labelmaker.t('common.status.information')
    case status.NOT_CLOSED_PAYMENTGROUP:
      return labelmaker.t('common.status.not_closed_paymentgroup')
    case status.CLOSED_PAYMENTGROUP:
      return labelmaker.t('common.status.closed_paymentgroup')
    case status.PAYMENTGROUP_CONTAINING_EXPIRED:
      return labelmaker.t('common.status.paymentgroup_containing_expired')
    case status.PAYMENTGROUP_CONTAINING_REFUSED:
      return labelmaker.t('common.status.paymentgroup_containing_refused')
    case status.NOT_CLOSED_FOLDER:
      return labelmaker.t('common.status.not_closed_folder')
    case status.CLOSED_FOLDER:
      return labelmaker.t('common.status.closed_folder')
    case status.FOLDER_CONTAINING_EXPIRED:
      return labelmaker.t('common.status.folder_containing_expired')
    case status.FOLDER_CONTAINING_REFUSED:
      return labelmaker.t('common.status.folder_containing_refused')
    case status.PROVIDER_INITIALIZED:
      return labelmaker.t('common.status.provider_not_closed')
    case status.PROVIDER_OPEN:
      return labelmaker.t('common.status.provider_not_closed')
    case status.PROVIDER_VALIDATED:
      return labelmaker.t('common.status.provider_waiting_validation')
    case status.PROVIDER_NOT_VALIDATED:
      return labelmaker.t('common.status.provider_not_payable')
    case status.PROVIDER_THIRD_PARTY_SENT:
      return labelmaker.t('common.status.provider_not_closed')
    case status.PROVIDER_THIRD_PARTY_VALIDATED:
      return labelmaker.t('common.status.provider_validated')
    case status.PROVIDER_THIRD_PARTY_REJECTED:
      return labelmaker.t('common.status.provider_not_closed')
    case status.PROVIDER_TO_REFRESH:
      return labelmaker.t('common.status.provider_to_refresh')
    case status.PROVIDER_CLOSED:
      return labelmaker.t('common.status.provider_validated')
    case status.SELLER_INITIALIZED:
      return labelmaker.t('common.status.seller_waiting')
    case status.SELLER_NOT_CLOSED:
      return labelmaker.t('common.status.seller_waiting')
    case status.SELLER_CLOSED:
      return labelmaker.t('common.status.seller_validated')
    case status.SELLER_REVOKED:
      return labelmaker.t('common.status.seller_not_validated')
    case status.DOC_INITIALIZED:
      return labelmaker.t('common.status.doc_initialized')
    case status.DOC_REQUEST_SENT:
      if (role === '0') {
        return labelmaker.t('common.status.doc_request_sent')
      } else {
        return labelmaker.t('common.status.doc_request_got')
      }
    case status.DOC_REQUEST_RECEIVED:
      if (role === '0') {
        return labelmaker.t('common.status.doc_request_transmitted')
      } else {
        return labelmaker.t('common.status.doc_request_received')
      }
    case status.DOC_REQUEST_REJECTED:
      return labelmaker.t('common.status.doc_request_rejected')
    case status.DOC_REQUEST_CANCELED:
      return labelmaker.t('common.status.doc_request_canceld')
    case status.DOC_REQUEST_OUT_TIME:
      return labelmaker.t('common.status.doc_request_out_time')
    case status.DOC_REQUEST_ACCEPTED:
      return labelmaker.t('common.status.doc_request_accepted')
    case status.DOC_REQUEST_REFUSED:
      return labelmaker.t('common.status.doc_request_refused')
    case status.DOC_REQUEST_READ:
      return labelmaker.t('common.status.doc_request_read')
    case status.DOC_SENT:
      if (role === '0') {
        return labelmaker.t('common.status.doc_got')
      } else {
        return labelmaker.t('common.status.doc_sent')
      }
    case status.DOC_RECEIVED:
      if (role === '0') {
        return labelmaker.t('common.status.doc_registered')
      }
      return labelmaker.t('common.status.doc_transmitted')
    case status.DOC_REJECTED:
      return labelmaker.t('common.status.doc_rejected')
    case status.DOC_VALIDATED:
      if (user.rights && user.rights.mp_admin === '1') {
        return labelmaker.t('common.status.doc_validated_lv1')
      } else {
        return labelmaker.t('common.status.doc_validated')
      }
    case status.DOC_REFUSED:
      return labelmaker.t('common.status.doc_revoked')
    case status.DOC_EXPIRED:
      return labelmaker.t('common.status.doc_expired')
    case status.DOC_VALIDATED_MAN:
      return labelmaker.t('common.status.doc_validated_lv2')
    case status.DOC_READ:
      return labelmaker.t('common.status.doc_read')
    case status.DOC_CANCELED:
      return labelmaker.t('common.status.doc_canceled')
    case status.DOC_NEGOTIATION_SENT:
      return labelmaker.t('common.status.doc_neg_sent')
    case status.DOC_NEGOTIATION_RECEIVED:
      return labelmaker.t('common.status.doc_neg_received')
    case status.DOC_NEGOTIATION_ACCEPTED:
      return labelmaker.t('common.status.doc_neg_accepted')
    case status.DOC_NEGOTIATION_REVOKED:
      return labelmaker.t('common.status.doc_neg_revoked')
    case status.DOC_THIRD_PARTY_SENT:
      return labelmaker.t('common.status.doc_third_party_sent')
    case status.DOC_THIRD_PARTY_RECEIVED:
      return labelmaker.t('common.status.doc_third_party_received')
    case status.DOC_THIRD_PARTY_REJECTED:
      return labelmaker.t('common.status.doc_third_party_rejected')
    case status.DOC_THIRD_PARTY_VALIDATED:
      return labelmaker.t('common.status.doc_third_party_validated')
    case status.DOC_THIRD_PARTY_REFUSED:
      return labelmaker.t('common.status.doc_third_party_refused')
    case status.DOC_CLOSING:
      return labelmaker.t('common.status.doc_closing')
    case status.DOC_CLOSED:
      return labelmaker.t('common.status.doc_closed')
    case status.DOC_PAID:
      return labelmaker.t('common.status.doc_paid')
    case status.DRAFT_NEED_COMPLETED:
      return labelmaker.t('common.status.draft_need_completed')
    case status.DRAFT_WAITING_VALIDATION:
      return labelmaker.t('common.status.draft_waiting_validation')
    case status.DRAFT_WAITING_UPPER_VALIDATION:
      return labelmaker.t('common.status.draft_waiting_upper_validation')
    case status.DRAFT_READY_TO_SEND:
      return labelmaker.t('common.status.draft_ready_to_send')
    case status.INVOICE_CREATED:
      return labelmaker.t('common.status.invoice_created')
    case status.INVOICE_PAYMENT_INITIALIZED:
      return labelmaker.t('common.status.invoice_payment_initialized')
    case status.INVOICE_TRANSFER_INITIALIZED:
      return labelmaker.t('common.status.invoice_transfer_initialized')
    case status.INVOICE_PAYMENT_DONE:
      return labelmaker.t('common.status.invoice_payment_done')
    case status.INVOICE_PARTIAL_PAYMENT:
      return labelmaker.t('common.status.invoice_partial_payment')
    case status.INVOICE_TOTAL_PAYMENT:
      return labelmaker.t('common.status.invoice_total_payment')
    case status.INVOICE_COMMISSION_PAYMENT_INITIALIZED:
      return labelmaker.t('common.status.invoice_commission_payement_initialized')
    case status.INVOICE_VENDOR_PAYMENT_INITIALIZED:
      return labelmaker.t('common.status.invoice_vendor_payment_initialized')
    case status.INVOICE_COMMISSION_PAYMENT_CONFIRMED:
      return labelmaker.t('common.status.invoice_commission_payment_confirmed')
    case status.INVOICE_VENDOR_PAYMENT_CONFIRMED:
      return labelmaker.t('common.status.invoice_vendor_payment_confirmed')
    case status.INVOICE_ERROR:
      return labelmaker.t('common.status.invoice_error')
    case status.INVOICE_CB_ERROR:
      return labelmaker.t('common.status.invoice_cb_error')
    case status.TRANSACTION_RECEIVED:
      return labelmaker.t('common.status.transaction_received')
    case status.TRANSACTION_NO_MATCH:
      return labelmaker.t('common.status.transaction_no_match')
    case status.TRANSACTION_AMBIGUOUS:
      return labelmaker.t('common.status.transaction_ambiguous')
    case status.TRANSACTION_LINKED:
      return labelmaker.t('common.status.transaction_linked')
    case status.TRANSACTION_ALLOCATED:
      return labelmaker.t('common.status.transaction_allocated')
    case status.TRANSACTION_VENTILATION:
      return labelmaker.t('common.status.transaction_ventilation')
    case status.TRANSACTION_IGNORED:
      return labelmaker.t('common.status.transaction_ignored')
    case status.KYCSTEP_CREATED:
      return labelmaker.t('common.status.kycstep_created')
    case status.KYCSTEP_WAITING:
      return labelmaker.t('common.status.kycstep_waiting')
    case status.KYCSTEP_VALIDATED:
      return labelmaker.t('common.status.kycstep_validated')
    case status.KYCSTEP_VALIDATED_MAN:
      return labelmaker.t('common.status.kycstep_validated_man')
    case status.KYCSTEP_REJECTED:
      return labelmaker.t('common.status.kycstep_rejected')
    case status.KYCSTEP_EXPIRED:
      return labelmaker.t('common.status.kycstep_expired')
    case status.KYCVERIFICATIONS_VALID:
      return labelmaker.t('common.status.kycverifications_valid')
    case status.KYCVERIFICATIONS_INFO:
      return labelmaker.t('common.status.kycverifications_info')
    case status.KYCVERIFICATIONS_WARNING:
      return labelmaker.t('common.status.kycverifications_warning')
    case status.KYCVERIFICATIONS_ERROR:
      return labelmaker.t('common.status.kycverifications_error')
    default:
      return labelmaker.t('common.status.unknown')
  }
}

export const statusLabelHistory = (labelmaker, statusCode) => {
  switch (statusCode) {
    case status.WAITING:
      return labelmaker.t('common.status.waiting_request')
    case status.ACCEPTED:
      return labelmaker.t('common.status.accepted_request')
    case status.MODIFIED:
      return labelmaker.t('common.status.modified_request')
    case status.REVOKED:
      return labelmaker.t('common.status.revoked_request')
    case status.ORDER_GENERATED:
      return labelmaker.t('common.status.payment_order_generated')
    case status.MADE:
      return labelmaker.t('common.status.payment_made')
    case status.INSTALLMENT_PAID:
      return labelmaker.t('common.status.installment_paid')
    case status.INST_ORDER_GENERATED:
      return labelmaker.t('common.status.inst_order_generated')
    case status.INST_MADE:
      return labelmaker.t('common.status.inst_made')
    case status.CANCELED:
      return labelmaker.t('common.status.aborted_request')
    case status.EXPIRED:
      return labelmaker.t('common.status.expired_request')
    case status.ACCEPTED_AND_PAYED:
      return labelmaker.t('common.status.accepted_nd_payed')
    case status.ACCEPTED_AND_PAYED_INST:
      return labelmaker.t('common.status.accepted_nd_payed_inst')
    case status.MODIFIED_AND_PAYED:
      return labelmaker.t('common.status.modified_n_pay_request')
    case status.MODIFIED_AND_PAYED_INST:
      return labelmaker.t('common.status.modified_n_pay_request_inst')
    case status.REJECTED:
      return labelmaker.t('common.status.rejected_request')
    case status.INFORMATION:
      return labelmaker.t('common.status.information')
    default:
      return labelmaker.t('common.status.unknown')
  }
}

export const statusIconHistory = (statusCode) => {
  switch (statusCode) {
    case status.WAITING:
      return 'icon-clock_forward'
    case status.DOC_RECEIVED:
      return 'icon-registered'
    case status.ACCEPTED:
      return 'icon-ok'
    case status.MODIFIED:
      return 'icon-edit'
    case status.REVOKED:
      return 'icon-error'
    case status.ORDER_GENERATED:
      return 'icon-receipt'
    case status.MADE:
      return 'icon-made'
    case status.INSTALLMENT_PAID:
      return 'icon-made'
    case status.CANCELED:
      return 'icon-canceled'
    case status.CANCELED_CONFIRM:
      return 'icon-canceled_confirm'
    case status.CANCELED_ABORT:
      return 'icon-canceled_abort'
    case status.EXPIRED:
      return 'icon-expired'
    case status.INST_ORDER_GENERATED:
      return 'icon-receipt_inst'
    case status.INST_MADE:
      return 'icon-made_inst'
    case status.ACCEPTED_AND_PAYED:
    case status.DOC_PAID:
      return 'icon-money'
    case status.ACCEPTED_AND_PAYED_INST:
      return 'icon-money_inst'
    case status.MODIFIED_AND_PAYED:
      return 'icon-money' // temp
    case status.MODIFIED_AND_PAYED_INST:
      return 'icon-money_inst' // temp
    case status.REJECTED:
      return 'icon-rejected'
    case status.INFORMATION:
      return 'icon-information'
    default:
      return 'icon-question'
  }
}

/* @author IRY - TLV 2020
* @brief Fonction centralisant tous les status utilisés sur MoneyRoad,
*         quelque soit le service utilisé
**/
export const statusIcon = (statusCode, negoCode = 0) => {
  switch (statusCode) {
    case status.WAITING:
      switch (negoCode) {
        case '0':
          return 'icon-clock_forward'
        case '10':
          return 'icon-message'
        case '11':
          return 'icon-messages'
        case '12':
          return 'icon-messages'
        default:
          return 'icon-clock_forward'
      }
    case status.ACCEPTED:
      return 'icon-ok'
    case status.MODIFIED:
      return 'icon-ok_edit'
    case status.REVOKED:
      return 'icon-error'
    case status.ORDER_GENERATED:
      return 'icon-receipt'
    // 04/12/20 icons
    case status.ORDER_SENT:
      return 'icon-order-sent'
    case status.ORDER_NOT_SENT:
      return 'icon-order-not-sent'
    case status.ORDER_VALIDATED:
      return 'icon-order-validated'
    case status.ORDER_REJECTED:
      return 'icon-rejected'
    case status.MADE:
      return 'icon-made'
    case status.INSTALLMENT_PAID:
      return 'icon-made'
    case status.INST_ORDER_GENERATED:
      return 'icon-receipt_inst'
    // 04/12/20 icons 2
    case status.INST_PAYMENT_SENT:
      return 'icon-inst-payment-sent'
    case status.INST_PAYMENT_NOT_SENT:
      return 'icon-inst-payment-not-sent'
    case status.INST_PAYMENT_VALIDATED:
      return 'icon-inst-payment-validated'
    case status.INST_PAYMENT_REJECTED:
      return 'icon-inst-payment-rejected'
    case status.INST_MADE:
      return 'icon-made_inst'
    case status.CANCELED:
      return 'icon-canceled'
    case status.CANCELED_CONFIRM:
      return 'icon-canceled_confirm'
    case status.CANCELED_ABORT:
      return 'icon-canceled_abort'
    case status.EXPIRED:
      return 'icon-expired'
    case status.ACCEPTED_AND_PAYED:
    case status.DOC_PAID:
      return 'icon-money' // temp
    case status.ACCEPTED_AND_PAYED_INST:
      return 'icon-money_inst' // temp
    case status.MODIFIED_AND_PAYED:
      return 'icon-money' // temp
    case status.MODIFIED_AND_PAYED_INST:
      return 'icon-money_inst' // temp
    // 04/12/20 icon 3
    case status.RECEIVED:
      return 'icon-mail_forward_alt'
    case status.REJECTED:
      return 'icon-rejected'
    case status.INFORMATION:
      return 'icon-information'
    case status.NOT_CLOSED_PAYMENTGROUP:
      return 'icon-not-closed-folder'
    case status.CLOSED_PAYMENTGROUP:
      return 'icon-closed-folder'
    case status.NOT_CLOSED_FOLDER:
      return 'icon-not-closed-folder'
    case status.CLOSED_FOLDER:
      return 'icon-closed-folder'
    case status.FOLDER_CONTAINING_EXPIRED:
      return 'icon-folder-containing-expired'
    case status.FOLDER_CONTAINING_REFUSED:
      return 'icon-folder-containing-refused'
    case status.DOC_INITIALIZED:
      return 'icon-clock_forward'
    case status.DOC_REQUEST_SENT:
      return 'icon-clock_forward'
    case status.DOC_REQUEST_RECEIVED:
      return 'icon-clock_forward'
    case status.DOC_REQUEST_REJECTED:
      return 'icon-error'
    case status.DOC_REQUEST_CANCELED:
      return 'icon-error'
    case status.DOC_REQUEST_OUT_TIME:
      return 'icon-error'
    case status.DOC_REQUEST_ACCEPTED:
      return 'icon-clock_forward'
    case status.DOC_REQUEST_REFUSED:
      return 'icon-error'
    case status.DOC_SENT:
      return 'icon-clock_forward'
    case status.DOC_RECEIVED:
      return 'icon-registered'
    case status.DOC_REJECTED:
      return 'icon-error'
    case status.DOC_VALIDATED:
      return 'icon-ok'
    case status.DOC_REFUSED:
      return 'icon-error'
    case status.DOC_EXPIRED:
      return 'icon-error'
    case status.DOC_VALIDATED_MAN:
      return 'icon-ok'
    case status.DOC_THIRD_PARTY_SENT:
      return 'icon-clock_forward'
    case status.DOC_THIRD_PARTY_RECEIVED:
      return 'icon-registered'
    case status.DOC_THIRD_PARTY_REJECTED:
      return 'icon-error'
    case status.DOC_THIRD_PARTY_VALIDATED:
      return 'icon-ok'
    case status.DOC_THIRD_PARTY_REFUSED:
      return 'icon-error'
    case status.DRAFT_NEED_COMPLETED:
      return 'fa fa-pencil iconStatus redFont'
    case status.DRAFT_WAITING_VALIDATION:
      return 'fa fa-clock-o iconStatus streammindBlueFont'
    case status.DRAFT_WAITING_UPPER_VALIDATION:
      return 'fa fa-clock-o iconStatus orangeFont'
    case status.DRAFT_READY_TO_SEND:
      return 'fa fa-check iconStatus greenFont'
    case status.PROVIDER_INITIALIZED:
      return 'icon-clock_forward'
    case status.PROVIDER_OPEN:
      return 'icon-clock_forward'
    case status.PROVIDER_VALIDATED:
      return 'icon-clock_forward'
    case status.PROVIDER_NOT_VALIDATED:
      return 'icon-error'
    case status.PROVIDER_THIRD_PARTY_SENT:
      return 'icon-clock_forward'
    case status.PROVIDER_THIRD_PARTY_VALIDATED:
      return 'icon-ok'
    case status.PROVIDER_THIRD_PARTY_REJECTED:
      return 'icon-error'
    case status.PROVIDER_TO_REFRESH:
      return 'icon-error'
    case status.PROVIDER_CLOSED:
      return 'icon-ok'
    case status.SELLER_INITIALIZED:
      return 'icon-clock_forward'
    case status.SELLER_NOT_CLOSED:
      return 'icon-clock_forward'
    case status.SELLER_CLOSED:
      return 'icon-ok'
    case status.SELLER_REVOKED:
      return 'icon-error'
    case status.INVOICE_CREATED:
      return 'icon-clock_forward'
    case status.INVOICE_PAYMENT_INITIALIZED:
      return 'icon-clock_forward'
    case status.INVOICE_TRANSFER_INITIALIZED:
      return 'icon-clock_forward'
    case status.INVOICE_PAYMENT_DONE:
      return 'icon-clock_forward'
    case status.INVOICE_PARTIAL_PAYMENT:
      return 'icon-clock_forward'
    case status.INVOICE_TOTAL_PAYMENT:
      return 'icon-clock_forward'
    case status.INVOICE_COMMISSION_PAYMENT_INITIALIZED:
      return 'icon-clock_forward'
    case status.INVOICE_VENDOR_PAYMENT_INITIALIZED:
      return 'icon-clock_forward'
    case status.INVOICE_COMMISSION_PAYMENT_CONFIRMED:
      return 'icon-ok'
    case status.INVOICE_VENDOR_PAYMENT_CONFIRMED:
      return 'icon-ok'
    case status.INVOICE_ERROR:
      return 'icon-error'
    case status.INVOICE_CB_ERROR:
      return 'icon-error'
    case status.TRANSACTION_RECEIVED:
      return 'icon-clock_forward'
    case status.TRANSACTION_NO_MATCH:
      return 'icon-error'
    case status.TRANSACTION_AMBIGUOUS:
      return 'icon-clock_forward'
    case status.TRANSACTION_LINKED:
      return 'icon-ok'
    case status.TRANSACTION_ALLOCATED:
      return 'icon-clock_forward'
    case status.TRANSACTION_VENTILATION:
      return 'icon-ok'
    case status.TRANSACTION_IGNORED:
      return 'icon-error'
    case status.KYCSTEP_CREATED:
      return 'icon-clock_forward'
    case status.KYCSTEP_WAITING:
      return 'icon-clock_forward'
    case status.KYCSTEP_VALIDATED:
      return 'icon-clock_forward'
    case status.KYCSTEP_VALIDATED_MAN:
      return 'icon-ok'
    case status.KYCSTEP_REJECTED:
      return 'icon-error'
    case status.KYCSTEP_EXPIRED:
      return 'icon-error'
    case status.KYCVERIFICATIONS_VALID:
      return 'icon-ok'
    case status.KYCVERIFICATIONS_INFO:
      return 'icon-information'
    case status.KYCVERIFICATIONS_WARNING:
      return 'icon-warning'
    case status.KYCVERIFICATIONS_ERROR:
      return 'icon-error'
    default:
      return 'icon-question'
  }
}

export const statusColor = (statusCode, negoCode) => {
  switch (statusCode) {
    case status.WAITING:
      switch (negoCode) {
        case '0':
          return 'blueIcon'
        case '10':
          return 'orangeIcon'
        case '11':
          return 'orangeIcon'
        case '12':
          return 'orangeIcon'
        default:
          return 'blueIcon'
      }
    case status.ACCEPTED:
      return 'greenIcon'
    case status.MODIFIED:
      return 'orangeIcon'
    case status.REVOKED:
      return 'redIcon'
    case status.ORDER_GENERATED:
      return 'yellowIcon'
    case status.MADE:
      return 'purpleIcon'
    default:
      return 'blackIcon'
  }
}

/**
* @brief Fonction centralisant tous les symboles selon les codes ISO 4217
**/
export const currencySymbol = (currency) => {
  let fromZoneCodeToSymbol = {
    'EUR': '€',
    'USD': '$',
    'GBP': '£',
    'JPY': '¥',
    'RUB': '₽'
  }
  if (fromZoneCodeToSymbol[currency] != null) {
    return fromZoneCodeToSymbol[currency]
  }
  return currency
}

export const getSeenStatusBackground = (isRead) => {
  if (isRead === '0') {
    return '#e6e7e8'
  }
  return '#FAFAFA'
}

export const getSeenStatusFontWeight = (isRead) => {
  if (isRead != null && isRead !== '1') {
    return '700'
  }
  return '500'
}

export const getDocumentLabel = (documentType) => {
  let fromIdToDocumentType = {
    '1': 'attachments.invce',
    'INVOICE': 'attachments.invce',
    'COST_ESTIMATE': 'businessDocuments.cost_estimate',
    '2': 'businessDocuments.cost_estimate'
  }
  return fromIdToDocumentType[documentType]
}

export const getPersonLabel = (personType) => {
  let fromIdToPersonType = {
    'CREDITOR': 'common.crditr_label_singular',
    'DEBTOR': 'common.debtor_label_singular',
    'RECIPIENT': 'common.recipient_label_singular',
    'SENDER': 'common.sender_label_singular'
  }
  return fromIdToPersonType[personType]
}

export const getCancelLabel = (code) => {
  switch (code) {
    case 'DU10': return 'requestToPay.dupplicate'
    case 'TE20': return 'requestToPay.tchncl_err'
    case 'WA30': return 'requestToPay.wrng_amnt'
    case 'UT40': return 'requestToPay.underlying_trncstn_mdf'
    case 'PI50': return 'requestToPay.pyr_id_incrrct'
    case 'AP60': return 'requestToPay.alrdy_payd_by_othr'
    case 'SF70': return 'requestToPay.suspicion_fraud'
    default: return ''
  }
}

/**
* @brief Fonction ajoutant un espace tous les 4 caractères d'un IBAN
**/
export const ibanWithSpaces = (iban) => {
  return iban.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()
}



// WEBPACK FOOTER //
// ./src/helpers/labels.js